import alertMsg from '@/utils/toastUtils';
import { ref } from 'vue';

/**
 * 페이지 당겨서 새로고침 훅 재사용하진않지만 따로 분리하고싶음
 * 2025.01.02 saylee
 * @returns 
 */
export function usePullToRefresh() {

const pullDistance = ref(0); // 당긴 거리
const spinnerPosition = ref(0); // 스피너의 위치 (당긴 만큼 이동)
const startTouchY = ref(0); // 터치 시작 위치
const minPullDistance = 120; // 새로 고침 시작을 위한 최소 당긴 거리 (픽셀)
const start = ref(false);

 // 요소로 접근하지않고 무조건 특정 urlPath에서는 동작안하도록하는 url 추가
const checkBlockedPaths = (path) => {
  let result = true

  const patterns = ['monitoringRegion'];
  const regex = new RegExp(`\\/(${patterns.join('|')})$`);
  if(regex.test(path)){
    result = false
  }
  return result
}

const isLoadingAble = () => {
  let isSubLoadingAble = true;  // 새로고침 가능여부  false면 동작안하기기
  const verticalScrollElement = document.querySelector(".page-contents");
  const popupElement = document.querySelector(".popup-wrap");
  const sideLayerElement = document.querySelector(".side-layer.show")
  const tabletShowElement = document.querySelector(".tablet.show")
 
  const currentPath = window.location.pathname;  // 현재 페이지의 경로만 확인
  // .page-contents 요소가없거나 , popup-wrap 요소가있는경우(팝업이 열려있는경우엔 당김동작안하도록)
  isSubLoadingAble = checkBlockedPaths(currentPath);
  if( (!verticalScrollElement) || (popupElement) || (sideLayerElement) || (tabletShowElement)) {
    isSubLoadingAble = false;
  }

  return isSubLoadingAble
}

const onTouchStart = (e) => {
  if(!isLoadingAble()) return false;

  const verticalScrollElement = document.querySelector(".page-contents");
  if(verticalScrollElement.scrollTop > 0){
    resetPull()
    return false;
  }
  start.value = true;
  startTouchY.value = e.touches[0].pageY;
};

const onTouchMove = (e) => {
  if(!isLoadingAble()) return false;
  const verticalScrollElement = document.querySelector(".page-contents");
  
  if(verticalScrollElement.scrollTop > 0){
    spinnerPosition.value=0;
    pullDistance.value = 0;
    startTouchY.value = e.touches[0].pageY;
    start.value = false
    return false;
  }
  if(!start.value) return false;

  const currentTouchY = e.touches[0].pageY;
  let distance = currentTouchY - startTouchY.value;
  if (distance > 0) {
    pullDistance.value = distance;
    // 스피너 위치 업데이트 (최대 거리 제한)
    spinnerPosition.value = Math.min(distance, minPullDistance);
    if(distance >= minPullDistance){
      // isRefreshing.value = true;
    }else{
      // isRefreshing.value = false;
    }
  }
};

const onTouchEnd = (e) => {
  if(!isLoadingAble()) return false;
  const verticalScrollElement = document.querySelector(".page-contents");
  if(verticalScrollElement.scrollTop > 0){
    resetPull()
  }
  if (pullDistance.value >= minPullDistance) {
    startRefresh();
  } else {
    resetPull()
  }

  start.value = false;
};

const startRefresh = () => {
  // isRefreshing.value = true;
  window.location.reload();

};

const resetPull = () => {
  pullDistance.value = 0;
  spinnerPosition.value = 0; // 스피너 위치 리셋
  startTouchY.value = 0;
};


return {
  pullDistance,
  spinnerPosition,
  startTouchY,
  minPullDistance,
  onTouchStart,
  onTouchMove,
  onTouchEnd
};
}